var render, staticRenderFns
import script from "./EmailVerified.vue?vue&type=script&lang=js"
export * from "./EmailVerified.vue?vue&type=script&lang=js"
import style0 from "./EmailVerified.vue?vue&type=style&index=0&id=2e08ff50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports